<template>
  <div class="page-container" v-if="state.teacherInfo">
    <div class="page-header">
      <van-image
        class="teacher-photo"
        mode="widthFix"
        :src="state.teacherInfo.imagePhoto"
      ></van-image>
      <div class="teacher-info">
        <div class="teacher-name">{{ state.teacherInfo.name }}</div>
        <div class="teacher-title">{{ state.teacherInfo.title }}</div>
        <div class="teacher-notes">{{ state.teacherInfo.notes }}</div>
      </div>
    </div>

    <div class="page-content">
      <div class="content-title">教学经历</div>
      <div class="content-item">{{ state.teacherInfo.experience }}</div>

      <div class="content-title" style="margin-top: 38px; margin-bottom: 16px">
        教学成果
      </div>
      <div
        class="content-item-row"
        v-for="(item, index) in getChildren(state.teacherInfo.achievement)"
        :key="index"
      >
        {{ item }}
      </div>

      <div class="content-title" style="margin-top: 38px">教学视频</div>
      <div class="content-video-list" v-if="state.teacherInfo.videoList && state.teacherInfo.videoList.length">
        <div
          class="content-item-vedio"
          v-for="(item, index) in state.teacherInfo.videoList"
          :key="index"
        >
          <video controls class="video-item" :poster="item.videoImg">
            <source :src="item.videoPath" type="video/mp4" />
          </video>
          <div class="date-time">{{item.teachDate}}</div>
          <div style="margin-left: 12px;margin-top: 4px;margin-bottom: 14px;font-family: PingFang SC;font-weight: 500;font-size: 15px;color: #535353;">{{item.videoDetail}}</div>
        </div>
      </div>
      <div v-else>
        <EmptyData style="margin-top: 36px"/>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, onMounted, reactive, ref } from "vue";
import EmptyDataCard from "@/components/EmptyDataCard.vue";
import { queryTeacherDetail } from "@/api/user";
import { useRoute } from "vue-router";
import { showToast } from "vant";
import EmptyData from '@/components/EmptyData.vue';
export default defineComponent({
  name: "GaoBuTeacher",

  components: {
    EmptyDataCard,
    EmptyData
  },

  setup() {
    const route = useRoute();

    console.log(route);

    const state = reactive({
      teacherInfo: {},
    });
    onMounted(() => {
      queryTeacherDetailData();
    });

    const queryTeacherDetailData = async () => {
      try {
        const result = await queryTeacherDetail({
          userId: route?.query?.id,
        });
        if (result.code === "00") {
          state.teacherInfo = result.data;
        } else {
          state.teacherInfo = null;
        }
      } catch (error) {
        console.log("error:>>>", error);
        state.teacherInfo = null;
      }
    };

    const getChildren = (row) => {
      if (!row) {
        return [];
      }
      return row.split("\n");
    };

    return {
      state,
      getChildren,
    };
  },
});
</script>

<style lang="scss" scoped>
.page-container {
  background: #e8f5ff;
  height: 100vh;
  width: 100%;
  overflow-y: scroll;
}

.page-header {
  display: flex;
  align-items: flex-start;
}

.teacher-photo {
  width: 145px;
  height: 155px;
  margin-top: 33px;
  margin-left: 14px;
}

.teacher-info {
  width: calc(100% - 174px);
  margin-left: 16px;
  text-align: left;
  margin-right: 14px;
}

.teacher-name {
  font-family: PingFang SC;
  font-weight: 500;
  font-size: 19px;
  color: #000000;
  margin-top: 60px;
}

.teacher-title {
  font-family: PingFang SC;
  font-weight: 500;
  font-size: 14px;
  color: #626262;
  margin-top: 8px;
}

.teacher-notes {
  font-family: PingFang SC;
  font-weight: 500;
  font-size: 13px;
  color: #626262;
  margin-top: 28px;
}

.page-content {
  margin-top: 34px;
  text-align: left;
  margin-left: 16px;
  margin-right: 16px;
}

.content-title {
  font-family: PingFang SC;
  font-weight: 500;
  font-size: 19px;
  color: #000000;
}

.content-item {
  font-family: PingFang SC;
  font-weight: 500;
  font-size: 14px;
  color: #626262;
  line-height: 20px;
  margin-top: 20px;
}

.content-item-row {
  font-family: PingFang SC;
  font-weight: 500;
  font-size: 14px;
  color: #626262;
  line-height: 20px;
  margin-top: 4px;
}

.content-video-list {
  display: flex;
  flex-direction: column;
  margin-top: 24px;
  padding-bottom: 24px;
}

.content-item-vedio {
  background-image: url("../../assets/video-item.png");
  background-repeat: no-repeat;
  width: 100%;
  background-size: cover;
  position: relative;
  background-position: center;
  margin-bottom: 9px;
}

.video-item {
  width: calc(100% - 28px);
  padding: 14px;
  height: 161px;
}

.date-time {
  margin-left: 14px;
  margin-top: -8px;
  margin-bottom: 8px;
  font-family: Source Han Sans SC;
  font-weight: 300;
  font-size: 13px;
  color: #000000;
}
</style>